import React from 'react';

const Spinner = ({ className, style }) => (
  <div className={`spinner-border ${className}`} role='status' style={style}>
    <span className='sr-only'>Loading...</span>
  </div>
);

export default Spinner;